import React from 'react';
import { Flex, Box } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import styles from './styles';

const {
  container,
  titleContainer,
  title,
  titleBorder,
  collectionContainer,
  collectionText,
  imagesStyles,
} = styles;

const ClientInfoBlock = ({ content: { text, collection }, iconSize }) => (
  <Flex sx={container}>
    <Flex sx={titleContainer}>
      <ContentText sx={title} content={text} />
      <Flex sx={titleBorder} />
    </Flex>
    {collection.map((col, index) => (
      <Box key={`client-info-block-section-${index}`}>
        {col.collection && (
          <Flex
            sx={{
              flexDirection: 'column',
              gap: iconSize === 'xxs' ? '12px' : '20px',
            }}
          >
            {col.collection.map((innerCol, index) => (
              <Flex
                key={`client-info-block-section-inner-collection-${index}`}
                sx={collectionContainer}
              >
                <Flex
                  sx={{
                    my: iconSize === 'xxs' ? '2px' : 0,
                    width: iconSize === 'xxs' ? '20px' : '24px',
                  }}
                >
                  <Icon content={innerCol.icon} size={iconSize} />
                </Flex>
                <Flex sx={collectionText}>
                  <ContentText content={innerCol.text} />
                </Flex>
              </Flex>
            ))}
          </Flex>
        )}
        {col.images && (
          <ContentImages sx={imagesStyles} content={{ images: col.images }} />
        )}
        {col.text && <ContentText content={col.text} />}
      </Box>
    ))}
  </Flex>
);

export default WithDefaultContent(ClientInfoBlock);
